const {
  REACT_APP_API_URI,
  REACT_APP_LOGROCKET_DOMAIN,
  REACT_APP_LOGROCKET_ENABLED,
  NODE_ENV,
} = process.env;

export const API_URI = REACT_APP_API_URI;
export const WS_URI = API_URI.replace(/^https:\/\//, 'wss://');

export const LOGROCKET_DOMAIN = REACT_APP_LOGROCKET_DOMAIN;
export const LOGROCKET_ENABLED = REACT_APP_LOGROCKET_ENABLED;
export const ENV = NODE_ENV;
